import React from 'react'
import './Alt.css'

const Alt = () => {
  return (
    <div class="footer-basic">
    <footer>
        <div class="social"><a href="https://www.linkedin.com/in/k%C3%BCr%C5%9Fat-boba%C3%A7-b82835219/"><i class="icon ion-social-linkedin"></i></a><a href="https://github.com/bobackursat99"><i class="icon ion-social-github"></i></a><a href="#"><i class="icon ion-social-instagram"></i></a><a href="#"><i class="icon ion-social-facebook"></i></a></div>
        <ul class="list-inline">
         
        </ul>
        <p class="copyright">@bobackursat99@gmail.com   © 2022</p>
    </footer>
</div>
  )
}

export default Alt